

export const SCRAPER_ENDPOINTS = {
  // Status
  STATUS: { path: `/scraper/status`, method: "GET" },
  
  GET_ANY_WEB: { path: `/scraper/getanyweb`, method: "GET" },
  GET_MV_STOCKS: { path: `/scraper/getmvstocks`, method: "GET" },
  GET_MV_NEWS: { path: `/scraper/getmvnews`, method: "GET" },
  GET_GAZETTE_ANNOUNCEMENTS: { path: `/scraper/getgazetteannouncements`, method: "GET" },
  GET_GAZETTE_ANNOUNCEMENT_DETAIL: { path: `/scraper/getgazetteannouncementdetail`, method: "GET" },

};